import { Typography } from "@mui/material";
import { Container } from "@mui/system";
import React, { useState } from "react";
import styles from "./Services.module.css";
import Grid from "@mui/material/Grid";
import ServicesCard from "../servicesCard/ServicesCard";
import calculator_icon from "assets/images/calculator-icon.svg";
import property_icon from "assets/images/property-icon.svg";
import prequalification_icon from "assets/images/prequalification-icon.svg";
import AppBackdrop from "../appBackdrop/AppBackdrop";
import MortgageCalculator from "./modal/MortgageCalculator/MortgageCalculator";
import { useNavigate } from "react-router-dom";
import ModalLayout from "component/modalLayout/ModalLayout";
import form_icon from "assets/images/application-form-icon.svg";
import { getResponsiveModalWidth } from "utils/helpers";
import Declaration from "pages/dashboard/applications/modal/applicationForm/components/formCategories/modals/declaration/Declaration";
import Disclaimer from "./modal/disclaimer/Disclaimer";

function Services() {
  const navigate = useNavigate();
  const [isOpenMortgateCalculator, setIsOpenMortgageCalculator] =
    useState(false);
  const [disclaimerOpen, setDisclaimerOpen] = useState(false);
  const [width, setWidth] = useState(getResponsiveModalWidth());
  return (
    <div className={styles.services}>
      <Container maxWidth="lg">
        <div className={styles.services_content}>
          <div className={styles.body}>
            <Grid sx={{ justifyContent: "center" }} container spacing={3}>
              <Grid item xs={12} sm={4}>
                <ServicesCard
                  handleOnClickLink={(e) => {
                    //e.preventDefault();
                    //setIsOpenMortgageCalculator(true);
                  }}
                  link="prequalification"
                  linkText="Go to Calculator"
                  icon={calculator_icon}
                  title="Mortgage Calculator"
                  description={
                    "Use the Mortgage Calculator to determine the maximum loan amount and monthly repayment you can access for your mortgage."
                  }
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <ServicesCard
                  handleOnClickLink={(e) => {
                    e.preventDefault();
                    setDisclaimerOpen(true);
                  }}
                  link="/"
                  linkText="View Listing"
                  icon={property_icon}
                  title="Property Listing"
                  description={
                    "Yet to find a property? Look no further. Visit property listing to search for your choice property and schedule a physical inspection."
                  }
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <ServicesCard
                  link="login"
                  linkText="Start application"
                  icon={prequalification_icon}
                  title="Start Mortgage Application"
                  description={
                    "Apply for a mortgage to own your dream home within minutes."
                  }
                />
              </Grid>
            </Grid>
          </div>
        </div>
      </Container>
      {isOpenMortgateCalculator && (
        <AppBackdrop
          handleCloseModal={() => {
            setIsOpenMortgageCalculator(false);
          }}
          openModal={isOpenMortgateCalculator}
          children={<MortgageCalculator />}
        />
      )}

      {disclaimerOpen && (
        <ModalLayout
          icon={form_icon}
          title="Stanbic IBTC Bank’s Disclaimer"
          handleClose={() => {
            setDisclaimerOpen(false);
          }}
          width={width}
          openModal={disclaimerOpen}
          children={<Disclaimer />}
        />
      )}
    </div>
  );
}

export default Services;